import { withInstallFunction } from '@lit-element/utils'

import Notify from './src/notify'

export const LtNotification = withInstallFunction(Notify, '$notify')
export default LtNotification

export * from './src/notification'
